module.exports = __webpack_public_path__ + "static/img/cloud.d34a92d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cloud.gif
// module id = ykY7
// module chunks = 1